"use strict";
export function extractZipCode(postalCode) {
  return postalCode?.split("-")?.[0] ?? "";
}
